/**
 * Reject if `promise` doesn't settle within `ms`.
 *
 * React Native's Android networking stack configures OkHttp with infinite
 * timeouts, so a stalled-but-open connection leaves a bare `fetch` pending
 * forever. Callers whose pending state gates retries (e.g. the heatmap
 * thunks' `loadingIds` dedup) race against this so a hung request can't
 * wedge them permanently. The underlying promise is not cancelled — a late
 * settlement is simply ignored.
 */
export async function rejectAfterTimeout<T>(
  promise: Promise<T>,
  ms: number,
  message: string,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  const timeout = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => {
      reject(new Error(message))
    }, ms)
  })
  try {
    return await Promise.race([promise, timeout])
  } finally {
    clearTimeout(timer)
  }
}
